import { MenuItem, Typography } from '@mui/material'
import { TFunction } from 'i18next'

type Props = {
  t: TFunction<'components'>
}

export const NoOptionItem = ({ t }: Props): React.JSX.Element => (
  <MenuItem disabled={true}>
    <Typography>{t('select.noOptionsAvailable')}</Typography>
  </MenuItem>
)
